import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const TwDispatchNotesLoading = (): JSX.Element => {
  return (
    <Stack className="dispatch-notes__loading" justifyContent={'center'}>
      <Box>
        <CircularProgress />
      </Box>
      <Typography fontSize={'16px'} fontWeight={500}>
        Loading messages
      </Typography>
      <Typography fontSize={'14px'}>Might take a few seconds</Typography>
    </Stack>
  );
};

export default TwDispatchNotesLoading;
